<template>
     <div class="container">
      <!--主播详情-->
      <div class="text_center"> <img class="anchor_img" v-bind:src="anchorInfo.face | objs" /> </div>
      <div class="anchor_info text_center">  
        <div class="anchor_name ">
            {{anchorInfo.name}}
        </div>
        <div class="text_center">{{anchorInfo.followCount}}人关注</div>
        <div class="anchor_button text_center"> 
        <div v-if="anchorInfo.isFollow==2">
          <div class="yiguanzhu" @click="anchorCollectCancel"> √ 已关注 </div>
        </div>
        <div v-else>
          <div class="anchor_attention" @click="anchorCollect" > + 关注 </div>
        </div>
        </div>
        <div class="anchor_introduce">
          <div class='introtitle'>简介</div>
          <div class='introcontent'>{{anchorInfo.intro}}</div>
        </div>
    
      </div>
      <!--专辑作品-->
      <div class="album">
        <div class="introtitle">{{anchorInfo.name}}的播音</div>  
              <div v-for="(item,index) in anchorBookList" :key="index">
                 <book-item v-bind:books="item"></book-item>
              </div> 
        <div class="text_center"><button v-if="moreBook" @click="moreBookList">加载更多》</button></div>
      </div>
      
    </div>
</template>
<script>
import BookItem from '@/components/BookItem'
import {getCookie} from '@/network/cookie.js'
var bookList = [];
export default {
    metaInfo() {
        return{
        title: this.anchorInfo.name+'--路上畅听主播节目列表',
        meta: [
          { vmid: 'keywords', name: 'keywords', content: this.$store.state.keywords },
          { vmid: 'description', name: 'description', content: this.$store.state.description }
        ] 
        }
    },
    data(){
        return{
            id:1,
            anchorInfo: [],
            anchorBookList:[],
            moreBook:true,
            pageIndex:0
        }
    },
    components:{
        BookItem
    },
     mounted() {
        if(this.$route.query.id){ 
            this.id = this.$route.query.id; 
        }
        this.getAnchorInfo();
        this.getAnchorBookList();
     },
     methods: {
        getAnchorInfo: function () {
            this.$http.get({
                url: 'xcx/anchor-info?anchorId='+this.id+'&sessionId='+getCookie('sessionId')
            }).then(res => {
                this.anchorInfo = res.data.data; 
            })
        },
        getAnchorBookList: function () {
            this.$http.get({
                url: 'xcx/anchor-book-list?anchorId='+this.id+'&pageSize=90&pageIndex='+this.pageIndex+'&sessionId='+getCookie('sessionId')
            }).then(res => {
                if(res.data.data.length > 0){
                    for(var i in res.data.data){
                        bookList.push(res.data.data[i])
                    }
                    this.anchorBookList = bookList
                }else{
                    this.moreBook=false
                } 
            })
        },
        moreBookList:function(){
            this.pageIndex++;
            this.getAnchorBookList();
        },
        anchorCollect:function(){ 
             this.$http.get({
                url: 'xcx/anchor-collect?anchorId='+this.id+ '&sessionId='+getCookie('sessionId')
            }).then(res => {
                if(res.data.meta.success){
                    this.getAnchorInfo()
                } 
            })
        },
        anchorCollectCancel:function(){ 
        this.$http.get({
                url: 'xcx/anchor-collect-cancel?anchorIds='+this.id+ '&sessionId='+getCookie('sessionId')
            }).then(res => {
                if(res.data.meta.success){
                    this.getAnchorInfo()
                } 
            })
        }
    }
}
</script>
<style scoped>
.text_center{
    text-align: center;
}
.anchor_img {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  margin-top: 50px;  
}

.anchor_name { 
  font-size: 20px;
  color: #323433;
  margin-top:14px; 
  font-weight: bold;
}
.anchor_name text{font-size: 13px; font-weight: 300; color: #00D1B0; }

.anchor_introduce {
  width: auto;
  clear: both;
  border-bottom: 1px solid #E6EBEB;
  padding: 10px 0;
  font-size: 14px;
  font-weight: 300;
  line-height: 20px;
  color: #323433;
  margin-top: 20px; 
}
.introcontent{
padding: 10px;
}
.anchor_button { 
margin-top: 10px;
}
button::after{background: none; border: none;}
.anchor_attention {
    width: 100px;
    margin: 0 auto;
   border: 1px;
border-radius: 12px;
background: #00D1B0;
color: #ffffff;
padding: 3px 10px; 
font-size: 12px; 
font-family:  'Segoe UI', Tahoma, Geneva, Verdana, sans-serif
}

.yiguanzhu {  
    width: 100px;
    margin: 0 auto;
border: 1px;
border-radius: 12px;
background: #B6BBBA;
color: #ffffff;
padding: 3px 10px; 
font-size: 12px; 
font-family:  'Segoe UI', Tahoma, Geneva, Verdana, sans-serif
} 
.introtitle{
clear: both;
font-size: 17px;
color: #323433;
font-weight: 600;
margin-bottom: 10px;
}

.album {
  width: auto;
  padding: 50px 0;
  overflow: hidden;
}
</style>